var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"train-timeline"},[_c('img',{staticClass:"timeline-image desktop",attrs:{"src":require("@/images/TrainTimelineDeskX4.png"),"alt":"Train Timeline"}}),_c('img',{staticClass:"timeline-image mobile",attrs:{"src":require("@/images/TrainTimelineMobX4.png"),"alt":"Train Timeline"}})])
}]

export { render, staticRenderFns }